import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { getArticle } from "@/lib/api";
import { Overline, GhostButton } from "@/components/site/Primitives";
import { NewsletterSection } from "@/components/site/Newsletter";

export default function ArticleDetail() {
  const { slug } = useParams();
  const [a, setA] = useState(null);
  useEffect(() => { getArticle(slug).then(setA).catch(() => {}); window.scrollTo(0, 0); }, [slug]);
  if (!a) return <div className="min-h-[60vh] flex items-center justify-center font-serif text-2xl text-brand-muted">Turning the page…</div>;

  return (
    <div data-testid="article-page">
      <article className="max-w-3xl mx-auto px-6 pt-20 pb-16">
        <div className="text-center">
          <Overline>{a.category} · {a.read_time}</Overline>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-light mt-5 mb-6 leading-tight">{a.title}</h1>
          <p className="font-sans text-xs uppercase tracking-[0.16em] text-brand-muted">By {a.author}</p>
        </div>
      </article>
      <div className="max-w-5xl mx-auto px-6"><img src={a.cover} alt={a.title} className="w-full aspect-[16/9] object-cover" /></div>
      <div className="max-w-2xl mx-auto px-6 py-16">
        {a.body.split("\n\n").map((p, i) => (
          <p key={i} className="font-body text-brand-body text-lg leading-loose mb-7 first:first-letter:text-6xl first:first-letter:font-serif first:first-letter:float-left first:first-letter:mr-3 first:first-letter:leading-[0.8] first:first-letter:text-brand-olive">{p}</p>
        ))}
        <div className="mt-12 pt-10 border-t border-brand-linen text-center">
          <p className="font-serif text-2xl italic text-brand-olive mb-6">With warmth, Agnes</p>
          <GhostButton to="/journal" testid="article-back-btn">Back to the Journal</GhostButton>
        </div>
      </div>
      <NewsletterSection />
    </div>
  );
}
